const PrivacyTopic = "Privacy";
const PrivacyCorpus = [
    {
        topic: PrivacyTopic,
        title: "Camera data",
        metadata: "video, seeing, computer vision",
        imagePath: "icons/privacy/darkmode/camera.svg",
        sentences: [
            "Camera images are used so that your agent can recognize you and detect your presence.",
            "Camera images are processed on your device and never sent to the cloud.",
            "Interaction data is sent securely to the cloud so that your agent can learn your habits over time."
        ],
        sentenceTopics: [
            "why, for what application, reason why camera data is used",
            "when, at what times it's on",
            ""
        ],
        testQueries: {
            [0]: ["What do you use the camera for?"],
            [1]: ["When is the camera on?", "Is the camera always watching me?", "Is video recorded?"],
        }
    },
    {
        topic: PrivacyTopic,
        title: "Face models",
        imagePath: "icons/privacy/darkmode/face.svg",
        metadata: "biometric",
        sentences: [
            "Your face model is trained with the camera during device setup and stored in the cloud " +
                "in an encrypted format.",
            "Your encrypted face model is shared between your devices so that you don’t need " +
                "to re-train with each new device."
        ],
        sentenceTopics: [
            "how face data is handled, processed, transmitted, stored",
            "why / for what reason, application face data is used and stored",
        ],
        testQueries: {
            [0]: ["How do you handle my face data?", "Do you send pictures of my face to the cloud?",
                "Do you store any biometric information about me?"],
            [1]: ["Why do you store my face data?"]
        }
    },
    {
        topic: PrivacyTopic,
        title: "Microphone data",
        imagePath: "icons/privacy/darkmode/microphone.svg",
        metadata: "audio, hearing",
        sentences: [
            "Voice is an optional input mode that may be more convenient than typing. It is enabled " +
                "when both Speech Recognition and Microphone permissions are granted.",
            "When enabled, the microphone is on and only listening while the app is open.",
            "All speech processing occurs on-device using Apple's built-in speech recognition. " +
                "Raw audio never leaves your device."
        ],
        sentenceTopics: [
            "what it is, how to grant permission for voice input",
            "when / at what times it's on",
            "on-device speech processing, audio not recorded or transmitted, not sent to cloud",
        ],
        testQueries: {
            [0]: ["How do I enable voice input?"],
            [1]: ["When is the agent listening to me?"],
            [2]: ["Do you send audio data to the cloud?", "Is microphone data recorded?"],
        }
    },
    {
        topic: PrivacyTopic,
        title: "Natural language understanding",
        imagePath: "icons/privacy/darkmode/nlu.svg",
        metadata: "intent recognition, text, natural language processing, NLP, NLU",
        sentences: [
            "Natural language understanding occurs on device.",
            "When your intents are recognized, your input (spoken or typed) is sent to the cloud for " +
                "processing and storage."
        ],
        sentenceTopics: [
            "on-device natural language processing",
            "text intents"
        ],
        testQueries: {
            [0]: ["Do you process natural language on-device?"],
            [1]: ["Does the system send intents to the cloud?", "Do you store recognized text in the cloud?"],
        }
    },
    {
        topic: PrivacyTopic,
        title: "Location data",
        metadata: "GPS",
        imagePath: "icons/privacy/darkmode/location.svg",
        sentences: [
            "Your location data is used to predict travel times and provide reminders.",
            "Location data is sent securely to the cloud at regular intervals when the app is open or " +
                "running in the background. This allows accurate estimations when you don’t have the app open."
        ],
        sentenceTopics: [
            "use of location data",
            "how user location data is handled, frequency of processing",
        ],
        testQueries: {
            [0]: ["What is my location used for?"],
            [1]: ["How is my location data handled?",
                "Is my location data sent to the cloud?",
                "Why does the app ask to use my location all the time?",
                "Does the app use location in the background?"],
        }
    },
    {
        topic: PrivacyTopic,
        title: "Apple Health data",
        metadata: "HealthKit",
        imagePath: "icons/privacy/darkmode/apple-health.svg",
        sentences: [
            "You can grant permissions for your agent to view your sleep and workout data from Apple " +
                "Health. If enabled, regular data recaps will be given and used to estimate and predict " +
                "your activity.",
            "The data is sent securely to the cloud for processing."
        ],
        sentenceTopics: [
            "why / for what reason, application Apple Health sleep workout data is used, what it's used for",
            "how Apple Health sleep workout data is handled, processed, transmitted"
        ],
        testQueries: {
            [0]: ["What do you do with my health data?"],
            [1]: ["Do you send my health data to the cloud?", "How do you handle my sleep data?"],
        }
    },
    {
        topic: PrivacyTopic,
        title: "Google Calendar data",
        metadata: "GCal",
        sentences: [
            "You can grant the agent read-only access to one or multiple Google Calendars. " +
                "The agent will then provide event reminders to help keep you on time.",
        ],
        sentenceTopics: [
            "why / for what reason, application Google Calendar data is used, what it's used for"
        ],
        testQueries: {
            [0]: ["What is Google Calendar data used for?"],
        }
    },
];
export { PrivacyCorpus, PrivacyTopic };
